/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZabbixTriggerComponent extends models.ZabbixComponentBase {
    getFixupPrototypeFunction() { return ZabbixTriggerComponent.fixupPrototype; }

    static newInstance(model: Partial<ZabbixTriggerComponent>): ZabbixTriggerComponent {
        let obj = Object.assign(new ZabbixTriggerComponent(), model);
        ZabbixTriggerComponent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZabbixTriggerComponent>): ZabbixTriggerComponent {
        if (!model) return null;
        return ZabbixTriggerComponent.newInstance(<ZabbixTriggerComponent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZabbixTriggerComponent) {
        if (!obj) return;

        models.ZabbixTriggerComponent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZabbixTriggerComponent): boolean {
        if (models.ZabbixComponentBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ZabbixTriggerComponent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Enabled or not
     */
    enabled: boolean;

    /**
     * Severity of Zabbix Trigger Component
     */
    severity: models.ZabbixTriggerSeverity;

    /**
     * Expression of the trigger component
     */
    expression: string;

}
